module.exports = __webpack_public_path__ + "static/media/license_b.678fa4a1.png";